<template>
  <hm-content title="">
    <!-- <div class="mb10 flex item-center">
      <el-button class="mr10" size="small" @click="outputExcel" type="text"
        >导出模板</el-button
      >
      <div class="delete mr20 pointer open-file">
        <span class="delete-icon hmicon icon-daoru"></span>
        <span>导入申报单</span>
        <input
          type="file"
          @change="importf"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </div>
    </div> -->
    <div class="mb10 flex item-center">
      <el-button class="mr10" size="small" @click="outputFlowExcel" type="text"
      >PK赛类型活动导出模板</el-button
      >
      <div class="delete mr20 pointer open-file">
        <span class="delete-icon hmicon icon-daoru"></span>
        <span>PK赛类型活动导入申报单</span>
        <input
          type="file"
          @change="importflow"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        />
      </div>
    </div>
    <div class="table" v-if="list.length">
      <!-- 添加提示区域 -->
      <div class="success-message">
          您可以在右侧“导出列队”中直接下载导入成功的单据的活动匹配详情
        </div>
      <el-table
        stripe
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        border
        :max-height="400"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="申报单号"
        >
          <template slot-scope="scope">
            {{ scope.row }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="errValidGoods" width="800px" title="提示">
      <div class="flex">
        <!-- <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div> -->
        <el-table
          v-if="errPhoneList.length"
          :data="errPhoneList"
          :max-height="400"
          border
          class="small-table mr10"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="错误手机号"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-if="errBarcodeList.length"
          :data="errBarcodeList"
          :max-height="400"
          border
          class="small-table"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="错误货号"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
// import { arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      errValidGoods: false,
      list: [],
      errPhoneList: [],
      errBarcodeList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        let tHeader = [];
        tHeader = ["导购手机号", "商品货号", "商品数量", "商城编码(供货商编码)"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        let name = "导入申报单模板";
        exportJsonToExcel(tHeader, data, name);
      });
    },
    // 导出excel
    outputFlowExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        let tHeader = [];
        tHeader = ["导购手机号", "商品货号", "商品数量", "商城编码(供货商编码)", "小票日期", "小票照片"];
        const filterVal = [];
        const data = this.formatJson(filterVal, []);
        let name = "导入PK赛类型活动申报单模板";
        exportJsonToExcel(tHeader, data, name);
      });
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let isValid = true;
        let isRequired = true;
        // let goodsSns = [];
        result.forEach(v => {
          v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : v[0];
          v[1] = v[1] ? (v[1] + "").replace(/\s*/g, "") : v[1];
          v[2] = v[2] ? (v[2] + "").replace(/\s*/g, "") : v[2];
          v[3] = v[3] ? (v[3] + "").replace(/\s*/g, "") : v[3];

          if (
            (!v[0] && v[0] != 0) ||
            (!v[1] && v[1] != 0) ||
            (!v[2] && v[2] != 0) ||
            (!v[3] && v[3] != 0)
          ) {
            isRequired = false;
          }
          formatResult.push({
            guiderPhone: v[0],
            barCode: v[1],
            goodsNum: v[2],
            storeCode: v[3]
          });
        });
        if (isRequired) {
          that.$store
            .dispatch("managerImportDeclare", formatResult)
            .then(res => {
              const { code, result } = res;
              if (code === "0") {
                const { declareSnList, errBarcodeList, errPhoneList } = result;
                if (errBarcodeList.length > 0 || errPhoneList.length > 0) {
                  that.errValidGoods = true;

                  that.errBarcodeList = errBarcodeList;
                  that.errPhoneList = errPhoneList;
                }
                that.list = declareSnList;
              }
            });
        } else {
          that.$message({
            message: "导入失败，请填写完成表格！",
            type: "warning"
          });
        }
        // formatResult = arrayUnique2(formatResult, "goodsSn");
        // goodsSns = formatResult.map(o => o.goodsSn);
        // that.$store.dispatch("queryGoodsSnOffline", { goodsSns }).then(res => {
        //   const { code, result } = res;
        //   if (code === "0") {
        //     if (result.notEffectiveGoods.length) {
        //       that.errValidGoods = true;
        //       that.errInputResult = result.notEffectiveGoods;
        //       that.$message({
        //         message: "部分货号导入失败！",
        //         type: "warning"
        //       });
        //     }
        //     result.effectiveGoods.forEach(v => {
        //       v.attrValue = v.goodsName;
        //       v.attrId = v.goodsSn;
        //       v.attrType = "goods";
        //     });
        //     that.leftData.push(...result.effectiveGoods);
        //     that.leftData = arrayUnique2(that.leftData, "attrId");
        //     that.leftData.forEach(v => {
        //       if (v.goodsName) {
        //         v.goodsInfo = v.goodsName;
        //       }
        //     });
        //   }
        // });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入excel
    importflow(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        // let isValid = true;
        let isRequired = true;
        // let goodsSns = [];
        result.forEach(v => {
          v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : v[0];
          v[1] = v[1] ? (v[1] + "").replace(/\s*/g, "") : v[1];
          v[2] = v[2] ? (v[2] + "").replace(/\s*/g, "") : v[2];
          v[3] = v[3] ? (v[3] + "").replace(/\s*/g, "") : v[3];

          if (
            (!v[0] && v[0] != 0) ||
            (!v[1] && v[1] != 0) ||
            (!v[2] && v[2] != 0) ||
            (!v[3] && v[3] != 0) 
          ) {
            isRequired = false;
          }
          formatResult.push({
            guiderPhone: v[0],
            barCode: v[1],
            goodsNum: v[2],
            storeCode: v[3],
            receiptDate: v[4],
            declareImg: v[5]
          });
        });
        if (isRequired) {
          that.$store
            .dispatch("managerImportDeclareFlow", formatResult)
            .then(res => {
              const { code, result } = res;
              if (code === "0") {
                const { declareSnList, errBarcodeList, errPhoneList } = result;
                if (errBarcodeList.length > 0 || errPhoneList.length > 0) {
                  that.errValidGoods = true;

                  that.errBarcodeList = errBarcodeList;
                  that.errPhoneList = errPhoneList;
                }
                that.list = declareSnList;
              }
            });
        } else {
          that.$message({
            message: "PK赛类型活动导入失败，请填写完成表格！",
            type: "warning"
          });
        }
        // formatResult = arrayUnique2(formatResult, "goodsSn");
        // goodsSns = formatResult.map(o => o.goodsSn);
        // that.$store.dispatch("queryGoodsSnOffline", { goodsSns }).then(res => {
        //   const { code, result } = res;
        //   if (code === "0") {
        //     if (result.notEffectiveGoods.length) {
        //       that.errValidGoods = true;
        //       that.errInputResult = result.notEffectiveGoods;
        //       that.$message({
        //         message: "部分货号导入失败！",
        //         type: "warning"
        //       });
        //     }
        //     result.effectiveGoods.forEach(v => {
        //       v.attrValue = v.goodsName;
        //       v.attrId = v.goodsSn;
        //       v.attrType = "goods";
        //     });
        //     that.leftData.push(...result.effectiveGoods);
        //     that.leftData = arrayUnique2(that.leftData, "attrId");
        //     that.leftData.forEach(v => {
        //       if (v.goodsName) {
        //         v.goodsInfo = v.goodsName;
        //       }
        //     });
        //   }
        // });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.success-message {
  padding: 10px;
  background-color: #fedeec;
  color: red; /* 文字颜色为红色 */
  border: 1px solid #fedeec;
  margin-bottom: 10px;
  font-weight: bold; /* 文字加粗 */
  font-size: 18px; /* 字号变大 */
  text-align: center; /* 文字居中对齐 */
}
</style>
